<template>
  <div
    v-if="(payload || isLoading) && canShow"
    :class="[
      'message-item',
      !isLastMessage && 'message-item-bottom',
      type === IM_Types.MSG_CUSTOM &&
        payload.description === 'gift' &&
        'gift-padding',
      isSelf && 'self-style'
    ]"
  >
    <div v-if="dateTimeString.date" class="time-line">
      {{ dateTimeString.date }}
    </div>
    <div
      v-if="
        type === IM_Types.MSG_CUSTOM &&
          (payload.description === 'follow' || payload.description === 'guard')
      "
      class="order-start is-reace"
    >
      <span>{{ dataMsg.content }}</span>
    </div>
    <div
      v-else-if="
        type === IM_Types.MSG_CUSTOM && dataMsg.messageType === 'AudioCall'
      "
      class="order-start is-reace"
    >
      <span>{{ getTipText() }}</span>
    </div>
    <div
      v-else-if="
        type === IM_Types.MSG_CUSTOM &&
          payload.description === 'OrderStatusChange' &&
          dataMsg.status === 'Processing'
      "
      class="order-start"
    >
      <span>{{ isSelf ? '您已確認訂單' : `${userProfile.nick}已接單` }}</span>
      <button @click="orderDetail(!isSelf)">查看詳情</button>
    </div>
    <div
      v-else-if="
        type === IM_Types.MSG_CUSTOM &&
          payload.description === 'OrderStatusChange' &&
          dataMsg.status === 'PlayerConfirm'
      "
      class="order-start"
    >
      <span>{{
        isSelf
          ? '你已確認訂單完成'
          : `${userProfile.nick}已確認訂單完成，記得確認完成喔。`
      }}</span>
      <button @click="orderDetail(!isSelf)">查看詳情</button>
    </div>
    <div
      v-else-if="
        type === IM_Types.MSG_CUSTOM &&
          payload.description === 'OrderStatusChange' &&
          dataMsg.status === 'Invalid'
      "
      class="order-start"
    >
      <span>{{
        isSelf ? `${userProfile.nick}的訂單已取消` : '您的訂單已取消'
      }}</span>
      <button @click="orderDetail(isSelf)">查看詳情</button>
    </div>
    <div
      v-else-if="
        type === IM_Types.MSG_CUSTOM &&
          payload.description === 'OrderStatusChange' &&
          dataMsg.status === 'REFUND_SUCCESS'
      "
      class="order-start"
    >
      <span>{{
        isSelf
          ? '你發起一筆退款'
          : `${userProfile.nick}發起了一筆退款，訂單金額已經退回您的帳戶`
      }}</span>
      <button @click="orderDetail(isSelf)">查看詳情</button>
    </div>
    <div
      v-else-if="
        type === IM_Types.MSG_CUSTOM && payload.description === 'comment'
      "
      class="user-comment"
    >
      <fps-star
        :count="dataMsg.starRating"
        :size="16"
        color="#FA006E"
        spacing="8px"
      />
      <template v-if="dataMsg.starRating === 5">
        <div class="comment-count">
          <p v-if="!dataMsg.content">您的超讚服務讓用戶打出五星好評！</p>
          <p v-else>
            {{ dataMsg.commentatorName | maxLengthName }}為您打出五星好評！
          </p>
          <p v-if="!dataMsg.content">再接再厲！</p>
        </div>
        <div class="comment-content">
          <p v-if="!dataMsg.content">讓用戶寫下有詳細描述的好評，</p>
          <p v-else-if="!showAllCotent" class="not-show-allcomment">
            {{ dataMsg.content }}
          </p>
          <p v-if="!dataMsg.content">可以幫助您獲得更多曝光和訂單喔！</p>
          <p
            v-else
            ref="comment_content"
            :class="!showAllCotent && 'cannot-see'"
          >
            {{ dataMsg.content }}
          </p>
        </div>
        <div
          v-if="openStatus"
          class="click-open-comment"
          @click="showAllCotent = !showAllCotent"
        >
          <span class="pointer">{{ showAllCotent ? '收起' : '展開' }}</span>
          <fps-icon
            :class="['arrow-right', showAllCotent && 'open-allcomment']"
            type="arrow-right"
            size="12"
          />
        </div>
      </template>
      <template v-else>
        <div class="comment-count">
          <p>用戶為您打出{{ parseWrite(dataMsg.starRating) }}星評價！</p>
        </div>
        <div class="comment-content">
          <p>
            若您對收到的評價不滿意，在對方打出評價48小時內可與對方溝通修改評價。
          </p>
        </div>
      </template>
    </div>
    <div
      v-else-if="
        type === IM_Types.MSG_CUSTOM &&
          payload.description === 'OrderStatusChange' &&
          dataMsg.status !== 'Effective'
      "
      class="order-start"
    >
      <span>{{
        isSelf ? dataMsg.toPlayerMessage : dataMsg.toNormalMessage
      }}</span>
      <button @click="torderDetail">查看詳情</button>
    </div>
    <div v-else :class="['message-inner', isSelf ? 'self' : 'not-self']">
      <div class="message-content">
        <fps-avatar
          class="avatar"
          :class="{ clickable: clickable }"
          :src="avatar"
          :guard-type="borderMethod()"
          :level="isSelf ? userInfo.userLevel : !canImpeach ? 0 : level"
          :dressup="isSelf ? userInfo.avatarFrame : dressup"
          @click.native="jumpMasterDetail"
        />
        <div class="message">
          <template v-if="isLoading">
            <div class="loading text-message">
              <img src="~@/assets/images/chat-message-loading.gif" alt="" />
            </div>
          </template>
          <template v-else>
            <div v-if="type === IM_Types.MSG_TEXT" class="text-message">
              <p
                v-for="(txt, index) in getWhiteSpace(payload.text)"
                class="text-wrap"
                :key="index"
              >
                {{ txt }}
              </p>
            </div>
            <div
              v-else-if="
                type === 'TIMCustomElem' && payload.description === 'linkNotify'
              "
              class="text-message link-text-message"
            >
              <p>{{ dataMsg.content }}</p>
              <p
                class="link-btn"
                v-if="dataMsg.btnText"
                @click="jumpPage(payload)"
              >
                {{ dataMsg.btnText }}
              </p>
            </div>
            <div
              v-else-if="
                type === 'TIMCustomElem' && payload.description === 'gameInvite'
              "
              class="text-message link-text-message"
            >
              <p>收到一條遊戲邀請，請打開app查看</p>
            </div>
            <div
              v-else-if="
                type === IM_Types.MSG_CUSTOM &&
                  payload.description === 'OrderStatusChange' &&
                  dataMsg.status === 'Effective'
              "
              class="text-message order-card pointer"
              :ref="!isSelf && !orderStatus && 'orderCard'"
              @click="orderDetail(isSelf)"
            >
              <div class="order-card-container">
                <div
                  class="order-message"
                  :class="
                    !isSelf &&
                      (!orderStatus || orderStatus === 'Effective') &&
                      'order-card-line'
                  "
                >
                  <img class="order-message-img" :src="dataMsg.gameImgUrl" />
                  <div class="order-message-text-container">
                    <span class="order-message-game-name">{{
                      dataMsg.gameName
                    }}</span>
                    <div v-if="dataMsg.salesPrice" class="sale-count">
                      ${{ dataMsg.salesPrice }}/{{
                        dataMsg.salesUnit | salesUnitTranslate
                      }}
                      * {{ dataMsg.count }}
                      <span v-if="dataMsg.giftNum"
                        >贈{{ dataMsg.giftNum }}</span
                      >
                    </div>
                    <span>總價 : ${{ dataMsg.moneyTotal }}</span>
                  </div>
                  <div v-if="!isSelf && !orderStatus" class="status-loading">
                    <i class="el-icon-loading" />
                  </div>
                </div>
                <div
                  v-if="!isSelf && orderStatus === 'Effective'"
                  class="order-status"
                >
                  <button class="receive-order" @click.stop="receiveOrder">
                    立即接單
                  </button>
                  <!-- <div class="received">
                    <img src="~@/assets/images/success-green.png" />
                    <span>已接單</span>
                  </div> -->
                </div>
              </div>
            </div>
            <!-- <div v-else-if="type === IM_Types.MSG_CUSTOM && payload.description === 'OrderStatusChange'" class="text-message">
              <p>我已經下單了喔，快接單一起玩吧～</p>
            </div> -->
            <div
              v-else-if="type === IM_Types.MSG_IMAGE && imageMessageInfo"
              class="image-message"
              :style="{
                width: imageMessageInfo.width,
                height: imageMessageInfo.height
              }"
            >
              <div v-if="isUploading" class="loading-mask">
                <img src="~@/assets/images/chat-message-loading.gif" alt="" />
              </div>
              <img
                :src="imageMessageInfo.url"
                @load="scrollIntoView"
                @click="previewImageDetail(imageMessageInfo)"
              />
            </div>
            <div
              v-else-if="
                type === IM_Types.MSG_CUSTOM &&
                  this.payload.description === 'gift'
              "
              class="text-message show-gift-container"
            >
              <img
                class="pointer"
                :src="dataMsg.giftImageUrl"
                @click.stop="openLottie"
                @load="imgIsLoading = false"
              />
              <div
                v-if="!imgIsLoading && dataMsg.giftCount > 1"
                class="gift-count"
              >
                x{{ dataMsg.giftCount }}
              </div>
              <div v-if="!imgIsLoading" class="click-open">
                <img src="~@/assets/images/click-open.png" />
                <span>{{ isSelf ? '送出禮物' : '送給你禮物' }}</span>
              </div>
            </div>
            <div v-else-if="type === IM_Types.MSG_SOUND" class="voice-msg">
              <FpsVoice :src="payload.url" />
            </div>
          </template>
        </div>
        <img
          class="sendError"
          v-if="isSelf && isSensitive"
          style="width:16px;height:16px;margin-right:10px"
          src="~@/assets/images/send-error.png"
        />
      </div>
      <div v-if="dateTimeString.time" class="time-tip">
        {{ dateTimeString.time }}
      </div>
    </div>
    <FeedDetail
      v-if="momentId"
      v-model="showDynamicDetail"
      :momentId="momentId"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import IM from '@/plugins/im';
import Lottie from '@/components/SendGifts/components/lottie.js';
import FeedDetail from '@/upgrade-page/views/user-feed/feed-detail';
import { acceptOrder } from '@/components/Order/order';
import FpsVoice from '@/components/FpsVoice';

export default {
  filters: {
    maxLengthName(name) {
      if (name.length > 8) {
        return name.substring(0, 7) + '...';
      }
      return name;
    }
  },
  components: {
    FeedDetail,
    FpsVoice
  },
  props: {
    isSelf: Boolean,
    payload: {
      type: Object,
      default() {
        return null;
      }
    },
    type: String,
    avatar: String,
    userProfile: Object,
    time: Number,
    lastTime: Number,
    isLoading: Boolean,
    isSensitive: Boolean,
    isUploading: Boolean,
    isLastMessage: Boolean,
    orderStatusLoading: Boolean,
    adverseRanking: [Object, Number],
    myRanking: [Object, Number],
    level: Number,
    canImpeach: Boolean,
    dressup: String // 聊天對象的頭像框
  },
  computed: {
    ...mapGetters(['userInfo']),
    clickable() {
      return (
        !this.isSelf &&
        ![
          'fpx666',
          this.$store.state.app.adminUuid,
          ...this.$store.state.app.systemUuid
        ].includes(this.userProfile.userID)
      );
    },
    dateTimeString() {
      const currentDate = new Date();
      const currentYear = currentDate.getFullYear();
      const currentDay = currentDate.getDate();
      const result = {};

      if (!this.lastTime) {
        result.data = '今天';
      }

      if (!this.time) return result;

      const currentMessageDate = new Date(this.time * 1000);
      const currentMessageYear = currentMessageDate.getFullYear();
      const currentMessageMonth = currentMessageDate.getMonth() + 1;
      const currentMessageDay = currentMessageDate.getDate();
      const currentMessageWeek = currentMessageDate.getDay();
      const lastMessageHour = currentMessageDate.getHours();
      const lastMessageMinutes = currentMessageDate.getMinutes();
      const weeks = ['日', '一', '二', '三', '四', '五', '六'];

      if (this.time - this.lastTime >= 300) {
        result.date =
          currentDay === currentMessageDay
            ? '今天'
            : `${
                currentYear === currentMessageYear
                  ? ''
                  : currentMessageYear + '年'
              }${currentMessageMonth}月${currentMessageDay}日 週${
                weeks[currentMessageWeek]
              }`;
      }

      result.time = `${lastMessageHour > 11 ? '下午' : '上午'}${
        lastMessageHour > 12 ? lastMessageHour - 12 : lastMessageHour
      }:${
        lastMessageMinutes > 9 ? lastMessageMinutes : '0' + lastMessageMinutes
      }`;

      return result;
    },
    rankingNo() {
      return this.isSelf ? this.adverseRanking : this.myRanking;
    },
    imageMessageInfo() {
      const len = this.payload.imageInfoArray.length;

      if (len) {
        const maxWidth = window.innerWidth >= 600 ? 280 : 141;
        let [image] = this.payload.imageInfoArray.filter(
          item => item.sizeType === 2
        );

        if (!image || !image.width) {
          image = this.payload.imageInfoArray[0];
        }

        const imageWidth = image.width;
        const imageHeight = image.height;

        const width = Math.min(imageWidth, maxWidth);

        return {
          url: image.url,
          width: width ? width + 'px' : 'auto',
          height: width ? imageHeight / (imageWidth / width) + 'px' : 'auto'
        };
      }

      return null;
    }
  },
  data() {
    return {
      IM_Types: IM.TYPES,
      imgIsLoading: true,
      orderStatus: '',
      dataMsg: {},
      canShow: true,
      showAllCotent: false,
      openStatus: false,
      showDynamicDetail: false,
      momentId: 0
    };
  },
  watch: {
    orderStatusLoading(value) {
      if (
        !value &&
        this.type === this.IM_Types.MSG_CUSTOM &&
        this.payload.description === 'OrderStatusChange'
      ) {
        this.getOrderMessage();
      }
    },
    isLoading(value) {
      if (!value) {
        this.disposeMSG_CUSTOM();
      }
    }
  },
  created() {
    this.disposeMSG_CUSTOM();
  },
  mounted() {
    this.scrollIntoView();
  },
  methods: {
    torderDetail() {
      this.$emit('orderDetail', {
        userType: this.dataMsg.buyerUserUuid === this.userInfo.uuid ? 'c' : 'b',
        orderNo: this.dataMsg.orderNo
      });
    },
    parseWrite(num) {
      if (!num) return '';
      return ['一', '两', '三', '四', '五'][num - 1];
    },
    getTipText() {
      if (this.isSelf) {
        switch (this.dataMsg.action) {
          case 1:
            return '您在App上發起了語音通話';
          case 2:
            return '通話已取消';
          case 3:
            return '通話無回應';
          case 4:
            return '通話無回應';
          case 5:
            return '通話結束';
        }
      } else {
        switch (this.dataMsg.action) {
          case 1:
            return '您收到一則語音通話，請在App上查看';
          case 2:
            return '通話已取消';
          case 3:
            return '未接來電，請在app上查看';
          case 4:
            return '未接來電，請在App上查看';
          case 5:
            return '通話已結束';
        }
      }
    },
    borderMethod() {
      const { rankingNo } = this;
      if (rankingNo === 0) {
        return 1;
      } else if (rankingNo === -1) {
        return 3;
      } else if (rankingNo) {
        return 2;
      } else {
        return 0;
      }
    },
    jumpPage() {
      const { dataMsg } = this;
      const { appUrl, webUrl } = dataMsg;
      if (
        (appUrl && appUrl.includes('/push-voice-room')) ||
        (webUrl && webUrl.includes('/push-voice-room'))
      ) {
        const regex = /push-voice-room\/\d+/;
        const url = appUrl || webUrl;
        // 使用正则表达式在 url 中匹配房间号
        const match = url.match(regex);
        if (match) {
          const roomNumber = match[0].substring(16);
          window.open(`/voice-room/${roomNumber}`, '_blank');
          return;
        }
      }
      if (dataMsg.webUrl) {
        if (dataMsg.webUrl.includes('/voice-room-list')) {
          this.$message('請下載app查看');
          return;
        }
        if (dataMsg.webUrl.includes('feed-detail')) {
          const queryObj = dataMsg.webUrl
            .split('?')[1]
            .split('&')
            .reduce((rs, item) => {
              const r = item.split('=');
              rs[r[0]] = r[1];
              return rs;
            }, {});
          if (queryObj.id) {
            this.momentId = +queryObj.id;
            this.showDynamicDetail = true;
            return;
          }
        }
        this.$util.openWindow(dataMsg.webUrl);
      }
    },
    disposeMSG_CUSTOM() {
      if (this.type === this.IM_Types.MSG_CUSTOM) {
        if (this.payload.description === 'comment' && this.isSelf) {
          this.canShow = false;
          return;
        }
        this.dataMsg = JSON.parse(this.payload.data);
        if (this.payload.description === 'OrderStatusChange') {
          if (!this.orderStatusLoading) this.getOrderMessage();
        }
        if (this.payload.description === 'comment' && this.dataMsg.content) {
          this.$nextTick(() => {
            this.$refs.comment_content.offsetHeight > 34 &&
              (this.openStatus = true);
          });
        }
      }
    },
    orderDetail(flag) {
      this.$emit('orderDetail', {
        userType: flag ? 'c' : 'b',
        orderNo: this.dataMsg.orderNo
      });
    },
    receiveOrder() {
      if (this.isReceiceOrdering) return;
      this.isReceiceOrdering = true;
      this.$confirm({
        content: '確認接下這單?',
        confirmButtonText: '確認接單',
        cancelButtonText: '再想想'
      })
        .then(() => {
          acceptOrder({ uuid: this.dataMsg.orderNo })
            .then(() => {
              this.isReceiceOrdering = false;
              this.orderStatus = 'Processing';
              // let message = {
              //   isUploading: true
              // }
              // const dataMsg = Object.assign({}, this.dataMsg, { status: 'Processing' })
              // const msg = IM.tim.createCustomMessage({
              //   to: this.userProfile.userID,
              //   conversationType: IM.TYPES.CONV_C2C,
              //   payload: {
              //     data: JSON.stringify(dataMsg),
              //     description: 'OrderStatusChange',
              //     extension: '「訂單訊息」'
              //   }
              // })

              // Object.assign(message, {
              //   payload: msg.payload,
              //   type: msg.type,
              //   avatar: this.userInfo.avatarUrl,
              //   isSelf: true,
              //   fromUuid: this.userInfo.uuid,
              //   time: msg.time
              // })

              // let messageList = this.$store.state.im.messageListMap

              // messageList.push(message)

              // this.$store.dispatch('im/updateMessageList', messageList)
            })
            .catch(() => {
              this.isReceiceOrdering = false;
              this.orderStatus = 'not-show';
              this.$message({
                message: '訂單狀態已改變,請刷新重試'
              });
            });
        })
        .catch(() => {
          this.isReceiceOrdering = false;
        });
    },
    getOrderMessage() {
      if (this.getOrderStatusing) return;
      this.getOrderStatusing = true;
      this.$http
        .get('/order/detail', {
          orderNo: this.dataMsg.orderNo
        })
        .then(rs => {
          this.orderStatus = rs.data.status;
          this.getOrderStatusing = false;
        })
        .catch(() => {
          this.getOrderStatusing = false;
        });
    },
    openLottie() {
      Lottie({
        giftId: this.dataMsg.giftId,
        basePath: this.dataMsg.giftAnimationUrl
      });
    },
    getWhiteSpace(text) {
      return text.split('\n');
    },
    jumpMasterDetail() {
      if (this.clickable) {
        this.$util.openWindow(`/player-detail/${this.userProfile.userID}`);
      }
    },
    scrollIntoView() {
      const placeholder = document.querySelector('#message-list-placeholder');

      if (placeholder && this.isLastMessage) {
        this.$nextTick(() => {
          this.$emit('getOrder');
          placeholder.scrollIntoView({
            // behavior: 'smooth',
            behavior: 'auto',
            block: 'end'
          });
        });
      }
    },
    previewImageDetail() {
      const imgInfo = this.payload.imageInfoArray.filter(
        item => item.sizeType === 1
      )[0];

      if (!imgInfo) return;

      const swipe = document.createElement('div');
      const img = document.createElement('img');
      const windowHeight = window.innerHeight;
      const windowWidth = window.innerWidth;

      const imageWidth = Math.min(windowWidth, imgInfo.width, 845);
      const imageHeight =
        imgInfo.width > 845
          ? imgInfo.height / (imgInfo.width / 845)
          : imgInfo.height;

      swipe.setAttribute(
        'style',
        `
        position: fixed;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        width: 100%;
        height: 100%;
        padding: 15px 0;
        overflow: auto;
        background: rgba(0, 0, 0, 0.6);
      `
      );

      img.setAttribute('src', imgInfo.url);
      img.setAttribute(
        'style',
        `
        max-width: 845px;
        width: ${imageWidth}px;
        height: auto;
        cursor: zoom-out;
        position: absolute;
        left: ${(windowWidth - imageWidth) / 2}px;
        ${
          imageHeight > windowHeight
            ? 'top: 15px;'
            : 'top: 50%; transform: translateY(-50%);'
        };
      `
      );
      img.setAttribute('data-w', imageWidth);

      swipe.appendChild(img);

      document.body.appendChild(swipe);

      swipe.addEventListener('click', () => {
        document.body.removeChild(swipe);
      });
    }
  }
};
</script>
<style lang="scss">
.voice-msg {
  width: 94px;
  height: 42px;
  padding: 0 !important;
}
.confirm-im-order {
  border-radius: 14px !important;
  width: 300px !important;
  padding: 30px 31px 25px !important;
  border: none;
  .el-message-box__message {
    font-size: 16px;
    line-height: 22px;
    text-align: center;
    color: #000000;
  }
  .el-message-box__btns {
    margin-top: 35px !important;
    display: flex;
    justify-content: space-between;
    & > button {
      width: 111px;
      height: 44px;
      border-radius: 22px;
      font-weight: 500;
      font-size: 16px;
      line-height: 22px;
      letter-spacing: -0.3px;
    }
  }
}
</style>
<style lang="scss" scoped>
.user-comment {
  width: 345px;
  margin: 0 auto;
  box-sizing: border-box;
  padding: 15px;
  background: #ffffff;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.03);
  border-radius: 15px;
  position: relative;
  overflow: hidden;
  @include flex(flex-start, flex-start, column);
  .comment-count {
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    color: #333333;
    margin-bottom: 6px;
    margin-top: 12px;
  }
  .comment-content {
    font-size: 12px;
    line-height: 17px;
    color: #999999;
    .not-show-allcomment {
      @include ellipsis(2);
    }
  }
  .cannot-see {
    position: absolute;
    width: 100%;
    visibility: hidden;
  }
  .click-open-comment {
    margin-top: 8px;
    font-size: 12px;
    line-height: 17px;
    color: #333333;
    @include flex(flex-start);
    .arrow-right {
      transition: all 0.3s;
    }
    .open-allcomment {
      transform: rotate(-90deg);
    }
  }
}

.order-start {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  line-height: 20px;
  max-width: 60%;
  margin: 0 auto;
  span {
    color: #666666;
    margin-right: 8px;
    @include ellipsis;
  }
  &.is-reace span {
    margin-right: 0;
    text-align: center;
    white-space: unset;
  }
  button {
    color: #fa006e;
    white-space: nowrap;
    &:hover,
    &:active {
      opacity: 0.5;
    }
  }
}
.gift-padding {
  padding: 10px 0 50px !important;
}
.show-gift-container {
  background: none !important;
  padding: 0 !important;
  position: relative;
  img {
    height: 127px;
  }
  .gift-count {
    white-space: nowrap;
    position: absolute;
    top: 6px;
    padding: 9px;
    background: #ea7bad;
    border-radius: 74px;
    font-weight: 800;
    font-size: 13px;
    line-height: 18px;
    letter-spacing: -0.5px;
    color: #fff;
  }
  .click-open {
    position: absolute;
    bottom: -21px;
    left: 0;
    right: 0;
    text-align: center;
    font-size: 0;
    img {
      height: 12px;
      vertical-align: middle;
      margin: 0 4.5px 0 2.5px;
    }
    span {
      vertical-align: middle;
      font-weight: 500;
      font-size: 11px;
      line-height: 15px;
      color: #999999;
      display: inline-block;
    }
  }
}
.message-item {
  // @include flex(flex-start);
  width: 100%;
  &.message-item-bottom {
    padding-bottom: 50px;
  }

  .time-line,
  .time-tip {
    color: #999999;
    font-size: 12px;
    line-height: 17px;
  }

  .time-line {
    text-align: center;
    margin-bottom: 25px;
  }
}

.message-inner {
  @include flex(flex-start, flex-end);
  min-height: 44px;
  &.not-self .gift-count {
    transform: translateX(2px);
    left: 100%;
  }
  &.self {
    flex-direction: row-reverse;

    .gift-count {
      transform: translateX(-2px);
      right: 100%;
    }
    .message-content {
      flex-direction: row-reverse;
    }

    .message {
      .text-message {
        color: white;
        // margin-right: 6px;
        background: #ea7bad;
        border-radius: 15px 15px 2.5px 15px;
      }
    }
  }

  .message-content {
    @include flex(flex-start, flex-end);
    max-width: 450px;
  }

  .avatar {
    width: 44px;
    height: 44px;
    flex-shrink: 0;
    &.clickable {
      cursor: pointer;
    }
    .img {
      width: 100%;
      height: 100%;
      border-radius: 50%;
    }
  }

  .message {
    margin: 0 5px;

    .text-message {
      min-height: 44px;
      padding: 12px 15px;
      background: white;
      border-radius: 15px 15px 15px 2.5px;
      font-weight: normal;
      font-size: 14px;
      line-height: 20px;
      color: #333;
      word-break: break-word;
      .text-wrap {
        min-height: 20px;
      }
      &.order-card {
        width: 280px;
        background: #ffffff;
        padding: 0px;
        &:active {
          background: #e5e5e5;
          &.order-card-line::after {
            background: #fff;
          }
        }
        .order-card-container {
          display: flex;
          flex-direction: column;
          position: relative;
          .status-loading {
            position: absolute;
            font-size: 18px;
            color: gray;
            bottom: 18px;
            right: 14px;
          }
        }
        .order-status {
          height: 51px;
          display: flex;
          justify-content: flex-end;
          align-items: center;
          .send-order {
            font-size: 14px;
            line-height: 14px;
            color: #333333;
            margin-right: 15px;
          }
          .receive-order {
            width: 74px;
            height: 31px;
            display: flex;
            justify-content: center;
            align-items: center;
            border-radius: 30px;
            background: #fa006e;
            font-weight: 500;
            font-size: 12px;
            line-height: 17px;
            color: #ffffff;
            letter-spacing: -0.000461946px;
            margin-right: 15px;
          }
          .received {
            display: flex;
            align-items: center;
            margin-right: 23px;
            img {
              height: 9px;
              margin-right: 4.5px;
            }
            span {
              font-size: 14px;
              line-height: 14px;
              color: #333333;
            }
          }
        }
        .order-message {
          margin: 20px 0px 0px 15px;
          padding-bottom: 15px;
          display: flex;
          align-items: center;
          position: relative;
          &.order-card-line::after {
            content: '';
            position: absolute;
            width: 100%;
            height: 1px;
            bottom: 0;
            background: #f6f6f6;
          }
        }
        .order-message-img {
          height: 60px;
          margin-right: 11px;
        }
        .order-message-text-container {
          display: flex;
          flex-direction: column;
          justify-content: center;
          font-size: 14px;
          line-height: 14px;
          height: 60px;
          letter-spacing: -0.000461946px;
          color: #333333;
          & > span {
            opacity: 0.8;
          }
          .sale-count {
            margin-bottom: 8px;
            display: flex;
            opacity: 0.8;
            span {
              color: #fa006e;
              margin-left: 5px;
            }
          }
          & > span:not(:last-child) {
            margin-bottom: 8px;
          }
        }
        .order-message-game-name {
          font-weight: 500;
          font-size: 16px;
          line-height: 16px;
          letter-spacing: -0.000568548px;
          opacity: 1 !important;
        }
      }
      .link-btn {
        color: #3e67c5;
        height: 24px;
        line-height: 24px;
        margin-top: 10px;
        cursor: pointer;
      }
    }

    .loading {
      @include flex();
      font-size: 0;
      height: 20px;

      img {
        width: 26px;
        height: 6px;
        vertical-align: middle;
      }
    }

    .image-message {
      position: relative;
      font-size: 0;

      > img {
        width: 100%;
        max-width: 280px;
        height: 100%;
        border-radius: 5px;
        background: #eee;
        cursor: zoom-in;
      }

      > div {
        @include flex();
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        width: 100%;
        height: 100%;
        background: rgba(196, 196, 196, 0.7);
        opacity: 0.7;

        img {
          width: 26px;
          height: 6px;
        }
      }
    }
  }
}

@media screen and (max-width: 599px) {
  .order-start {
    max-width: 80%;
  }
  .message-item {
    padding: 10px 0;
  }

  .message-inner {
    width: 100%;

    &.self {
      .message {
        margin: 0 5px;
      }
    }

    .avatar {
      width: 30px;
      height: 30px;
    }

    .message {
      max-width: 232px;
      margin: 0 5px;

      .image-message {
        position: relative;
        font-size: 0;

        > img {
          width: 100%;
          max-width: 141px;
          height: 100%;
          border-radius: 5px;
          background: #eee;
        }

        > div {
          @include flex();
          position: absolute;
          top: 0;
          left: 0;
          bottom: 0;
          right: 0;
          width: 100%;
          height: 100%;
          background: rgba(196, 196, 196, 0.7);
          opacity: 0.7;

          img {
            width: 26px;
            height: 6px;
          }
        }
      }
    }

    .time-tip {
      margin: 0;
    }
  }
  .order-card {
    width: 232px !important;
  }
}
@media screen and (max-width: 320px) {
  .message {
    max-width: 203px !important;
  }
}
</style>
